"use strict";
/* tslint:disable */
var TPurchases = (function () {
    var api = {};
    api.buildView = function (mode, purchase, context) {
        context = context || {};
        context.isPurchase = true;
        var templateType = BetSlipTemplateConroller.getPurchasesTemplate(BetSlip.TemplateType);
        if (context.buildInner) {
            return templateType.buildInner(mode, purchase, context);
        }
        context.isSingle = Modes.isSingleMode(purchase.Mode || BetSlip.CurrentMode);
        if (purchase.updateContext) {
            context = purchase.updateContext(context);
        }
        return templateType.buildInner(mode, purchase, context);
    };
    return api;
}());
window.TPurchases = TPurchases;
//# sourceMappingURL=TPurchases.js.map